"use client"

import React, { ReactNode } from "react"

import { ScrollProvider } from "../ScrollContext"

interface ScrollHandlerProps {
  children: ReactNode
}

/**
 * 滚动监听组件
 * 监听页面滚动，提供滚动状态给子组件
 * 兼容 React 19，使用 Context 替代 render props
 */
export function ScrollHandler({ children }: ScrollHandlerProps) {
  return <ScrollProvider>{children}</ScrollProvider>
}
